import { ENDS, ETaxVariant } from 'cashbox';

export enum EComboItemType {
  GOOD = 'GOOD',
  SERVICE = 'SERVICE',
}

export type TCombo = {
  id: number;
  title: string;
  amount: number;
  price: number;

  tariff: {
    id: number;
    title: string;
    duration: number;
    cost: number;
    time_from: string;
    time_to: string;
    use_global_discounts: boolean;
    has_fixed_finish_time: boolean;
    per_minute: boolean;
    pausable: boolean;
    booked: boolean;
  };

  items: {
    entity_type: EComboItemType;

    entity: {
      id: number;
      title: string;
      cost: number;
      amount: number;
      use_global_discounts: boolean;
      use_fair_sign: boolean;
      vat: ENDS | null;
      tax_system: ETaxVariant | null;
      is_excise: boolean;
    };
  };
};
